import './styles/index.css';

import { syncCartByCartId } from './api';
import { createItsApiClient } from './base-api/api-client';
import { CART_LOADER, PRODUCTION_STORE_HASH } from './constants';
import {
  attachCartEventListeners,
  beforeMountCartWidget,
  onCartRefreshContentCompleted,
  shouldRunSyncCart,
} from './helpers/cart';
import { injectGlobalStyleSheet } from './helpers/dom';
import { validateItsServices, validateStencilUtils } from './helpers/validate';
import { log } from './utils';
import { events } from './utils/events';
import { modeBanner } from './utils/mode-banner';
import { mountCartWidget } from './widgets/mount-cart';
import { mountPdpWidget } from './widgets/mount-pdp';

// init loader
(() => {
  window.itsServices = window.itsServices || {};
  console.log('🚀 ~ window.itsServices:', window.itsServices);

  const itsServicesCheck = validateItsServices(window.itsServices);
  if (!itsServicesCheck.ok) return log.error(itsServicesCheck.msg);

  const stencilCheck = validateStencilUtils(window.stencilUtils);
  if (!stencilCheck.ok) return log.error(stencilCheck.msg);

  Object.assign(window.itsServices, {
    mountPdpWidget,
    mountCartWidget,
    onCartRefreshContentCompleted,
    events,
    api: createItsApiClient({
      storeHash: window.itsServices.storeHash,
      isStaging: !PRODUCTION_STORE_HASH.includes(window.itsServices.storeHash),
    }),
  });

  injectGlobalStyleSheet();

  switch (window.itsServices.pageType) {
    case 'product':
      window.itsServices.mountPdpWidget();
      break;
    case 'cart':
      CART_LOADER.show();
      attachCartEventListeners();
      beforeMountCartWidget(async () => {
        if (await shouldRunSyncCart()) {
          const data = await syncCartByCartId();

          if (data?.needs_refresh) {
            window.location.reload();
          }
        }

        window.itsServices.mountCartWidget();

        CART_LOADER.hide();
      });
      break;

    default:
      break;
  }

  modeBanner();
})();
